import { AccountingDocument } from '@/models/accounting-document.model';

export const paymentsMixins = {
  calculateTotalAmount(documents: AccountingDocument[]): number {
    let result = documents.reduce(
      (acc: number, document) => acc + (parseFloat(document.outstandingValue as any) || 0),
      0,
    );

    result = parseFloat(result.toFixed(2));

    return result;
  },
  mapToAdyenLocale(userLocale: string): string {
    const supportedAdyenLocales = [
      'da_DK',
      'de_DE',
      'en_US',
      'es_ES',
      'fr_FR',
      'it_IT',
      'ja_JP',
      'nl_NL',
      'no_NO',
      'pl_PL',
      'pt_BR',
      'sv_SE',
      'zh_CN',
    ];

    return supportedAdyenLocales.find((adyenLocale) => adyenLocale.includes(userLocale.substring(0, 2))) ?? userLocale;
  },
};
